// Estado de una matrícula de usuario, tal como se muestra en el panel.
// Lo comparten Usuarios matriculados y Estadísticas para que cuenten igual.
import dayjs from 'dayjs';

export const DIAS_POR_VENCER = 30;

/**
 * `revocacion_sin_aplicar`: el backend registra la revocación (motivo, quién, cuándo)
 * pero no cambia `estado`, así que la matrícula sigue activa y sigue sirviendo para
 * inscribirse. Se muestra aparte para no hacer creer que quedó revocada.
 */
export const ESTADOS = {
  vigente: { label: 'Vigente', cls: 'bg-blue-50 text-primary', punto: 'bg-primary' },
  por_vencer: { label: 'Por vencer', cls: 'bg-secondary/40 text-[#5c4300]', punto: 'bg-secondary' },
  vencida: { label: 'Vencida', cls: 'bg-gray-100 text-gray-600', punto: 'bg-gray-400' },
  // 2 años sin compras en el recinto (también vence la de por vida).
  caducada: { label: 'Caducada por inactividad', cls: 'bg-gray-100 text-gray-600', punto: 'bg-gray-400' },
  renovada: { label: 'Renovada', cls: 'bg-gray-100 text-gray-600', punto: 'bg-gray-400' },
  cancelada: { label: 'Cancelada', cls: 'bg-red-50 text-red-700', punto: 'bg-red-500' },
  revocacion_sin_aplicar: { label: 'Revocación sin aplicar', cls: 'bg-red-50 text-red-700', punto: 'bg-red-500' },
};

export const estadoDe = (m) => {
  if (m.estado === 'cancelada') return 'cancelada';
  if (m.estado === 'renovada') return 'renovada';
  if (m.estado === 'vencida') return m.motivoVencimiento === 'inactividad' ? 'caducada' : 'vencida';
  // estado === 'activa'
  if (m.desactivadoEn) return 'revocacion_sin_aplicar';
  if (m.tipoVigencia === 'indefinida' || !m.fechaVencimiento) return 'vigente';
  const dias = dayjs(m.fechaVencimiento).startOf('day').diff(dayjs().startOf('day'), 'day');
  if (dias < 0) return 'vencida';
  if (dias <= DIAS_POR_VENCER) return 'por_vencer';
  return 'vigente';
};

export const sigueActiva = (m) => ['vigente', 'por_vencer'].includes(estadoDe(m));

/** Pagada si tiene orden de compra (web) o venta en caja; si no, fue registrada a mano o por carga masiva. */
export const tipoRegistro = (m) => (m.ordenCompra || m.ventaPresencial ? 'pago' : 'manual');

/** "1 año", "3 años", "De por vida". Las matrículas viejas sin aniosVigencia son de 1 año. */
export const textoVigencia = (m) => {
  if (m.tipoVigencia !== 'anual') return 'De por vida';
  const n = m.aniosVigencia || 1;
  return n === 1 ? '1 año' : `${n} años`;
};

/** Cómo entró la matrícula, para mostrar. */
export const textoOrigen = (m) => ({
  online: 'Pago web', presencial: 'Pago en caja', manual: 'Registro manual', carga_masiva: 'Carga masiva',
}[m.origen] || (m.ordenCompra ? 'Pago web' : 'Registro manual'));
